import { deviceUtil, patchRequireNativeComponent } from '@qnpm/q-design-utils';
import FloatCalendar from './FloatCalendar';
import FullScreenCalendar from './FullScreenCalendar';
// 防止重复引入模块报错
patchRequireNativeComponent();
// 获取设备分级
deviceUtil.initDeviceLevel();
export * from './Calendar';
export { FloatCalendar, FullScreenCalendar };
export { HolidayData } from './utils/holidayUtil';
